import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ConnectedSeparateStayDate } from '../SeparateStayDate';
import { DatePicker } from '../../../components/DatePicker';

const DateDesktop = ({
    index,
    onChangeFocus,
    open,
    placeholderKey,
    isDatesRangeShown,
    roundedCornersFirst,
    roundedCornersLast,
}) => {
    const { t } = useTranslation();
    return (
        <ConnectedSeparateStayDate index={index}>
            {({ error, dates, minDate, maxDate, setValue, value }) => (
                <DatePicker
                    value={value}
                    onSelect={setValue}
                    dates={dates}
                    isDatesRangeShown={isDatesRangeShown}
                    maxDate={maxDate}
                    minDate={minDate}
                    placeholder={t(placeholderKey)}
                    validationError={error}
                    open={open}
                    onChangeFocus={onChangeFocus}
                    roundedCornersFirst={roundedCornersFirst}
                    roundedCornersLast={roundedCornersLast}
                />
            )}
        </ConnectedSeparateStayDate>
    );
};

DateDesktop.propTypes = {
    index: PropTypes.number.isRequired,
    onChangeFocus: PropTypes.func.isRequired,
    isDatesRangeShown: PropTypes.bool,
    open: PropTypes.bool,
    placeholderKey: PropTypes.string.isRequired,
    roundedCornersFirst: PropTypes.bool,
    roundedCornersLast: PropTypes.bool,
};

DateDesktop.defaultProps = {
    isDatesRangeShown: false,
    open: false,
    roundedCornersFirst: false,
    roundedCornersLast: false,
};

export { DateDesktop as SeparateStayDateDesktop };
